import { api } from "./apiClient";

export const llmAPI = {
    rewrite: (
        text,
        { style = "professional", keep_meaning = true, instruction = "" } = {}
    ) =>
        api.post("/llm/rewrite", {
        text,
        style,
        keep_meaning,
        instruction,
        }),
};
